angular.module('mercury.modules.qa.menumate.billtenders')
.controller('QaMenumateBillTendersReportCtrl', ["$http", "reporttime", "$scope", "title", "settings", function($http, reporttime, $scope, title, settings) {
  title.set('Bill Tenders Report');

  $scope.loading = $http.get(settings.apiHost + '/r/PosQaMenumateBillTenders', {
    params: {
      startTime: reporttime.start(),
      endTime: reporttime.end()
    }
  });

  $scope.loading.then(function(response) {
    title.setSubheader(response.data.notes);
    $scope.tableData = response.data.lines;

    $scope.price = 0;
    $scope.changeRecv = 0;
    $scope.tip = 0;
    $scope.paidExclChange = 0;

    $scope.terminals = {};

    angular.forEach(response.data.lines, function(line) {
      if (!$scope.terminals[line.terminalName]) {
        $scope.terminals[line.terminalName] = {
          terminalName: line.terminalName,
          paymentTypes: {},
          price: 0,
          changeRecv: 0,
          tip: 0,
          paidExclChange: 0
        };
      }

      if (!$scope.terminals[line.terminalName].paymentTypes[line.payType]) {
        $scope.terminals[line.terminalName].paymentTypes[line.payType] = {
          payType: line.payType,
          lines: [],
          price: 0,
          changeRecv: 0,
          tip: 0,
          paidExclChange: 0
        };
      }

      $scope.terminals[line.terminalName].paymentTypes[line.payType].lines.push(line);

      $scope.terminals[line.terminalName].paymentTypes[line.payType].price += line.price;
      $scope.terminals[line.terminalName].paymentTypes[line.payType].changeRecv += line.changeRecv;
      $scope.terminals[line.terminalName].paymentTypes[line.payType].tip += line.tip;
      $scope.terminals[line.terminalName].paymentTypes[line.payType].paidExclChange += line.paidExclChange;

      $scope.terminals[line.terminalName].price += line.price;
      $scope.terminals[line.terminalName].changeRecv += line.changeRecv;
      $scope.terminals[line.terminalName].tip += line.tip;
      $scope.terminals[line.terminalName].paidExclChange += line.paidExclChange;

      $scope.price += line.price;
      $scope.changeRecv += line.changeRecv;
      $scope.tip += line.tip;
      $scope.paidExclChange += line.paidExclChange;
    });
  });
}]);
